import React from "react";
import { Field, SelectInput, TextInput } from "./Fields";
import { COUNTRIES, MY_STATES } from "@/lib/constants";

export const AddressFields = ({ prefix, value, onChange, errors = {}, disabled = false, lockCountry = false }) => {
  const set = (k) => (e) => onChange({ [k]: e.target.value });
  const isSG = value.country === "Singapore";

  return (
    <div className="space-y-5">
        <Field id={`${prefix}-line1`} label="Alamat Baris 1" error={errors.line1}>
          <TextInput
            id={`${prefix}-line1`}
            data-testid={`input-${prefix}-line1`}
            value={value.line1}
            onChange={set("line1")}
            disabled={disabled}
            error={errors.line1}
            maxLength={80}
            placeholder="No. 25, Jalan Melati 3"
          />
      </Field>

      <Field id={`${prefix}-line2`} label="Alamat Baris 2" optional>
        <TextInput
          id={`${prefix}-line2`}
          data-testid={`input-${prefix}-line2`}
          value={value.line2}
          onChange={set("line2")}
          disabled={disabled}
          placeholder="Taman Sejahtera"
        />
      </Field>

      <div className="grid sm:grid-cols-2 gap-5">
        <Field id={`${prefix}-postcode`} label="Poskod" error={errors.postcode}>
          <TextInput
            id={`${prefix}-postcode`}
            data-testid={`input-${prefix}-postcode`}
            value={value.postcode}
            onChange={set("postcode")}
            disabled={disabled}
            error={errors.postcode}
            inputMode="numeric"
            placeholder={isSG ? "238859" : "06700"}
          />
        </Field>
        <Field id={`${prefix}-city`} label={isSG ? "Bandar / Kawasan" : "Bandar"} error={errors.city}>
          <TextInput
            id={`${prefix}-city`}
            data-testid={`input-${prefix}-city`}
            value={value.city}
            onChange={set("city")}
            disabled={disabled}
            error={errors.city}
            placeholder={isSG ? "Orchard" : "Pendang"}
          />
        </Field>
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        <Field id={`${prefix}-country`} label="Negara">
          <SelectInput
            id={`${prefix}-country`}
            data-testid={`select-${prefix}-country`}
            value={value.country}
            onChange={(e) => onChange({ country: e.target.value, state: "" })}
            disabled={disabled || lockCountry}
          >
            {COUNTRIES.map((c) => (
              <option key={c} value={c}>
                {c === "Singapore" ? "Singapura" : c}
              </option>
            ))}
          </SelectInput>
        </Field>

        {!isSG && (
          <Field id={`${prefix}-state`} label="Negeri / Wilayah" error={errors.state}>
            <SelectInput
              id={`${prefix}-state`}
              data-testid={`select-${prefix}-state`}
              value={value.state}
              onChange={set("state")}
              disabled={disabled}
              error={errors.state}
            >
              <option value="">Sila pilih negeri</option>
              {MY_STATES.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </SelectInput>
          </Field>
        )}
      </div>
    </div>
  );
};
